/* eslint-disable */ 
import React from 'react';
import {AppRegistry} from 'react-native';
import Apps from './App';
 
AppRegistry.registerComponent('App', () => Apps);
AppRegistry.runApplication('App', {rootTag: document.getElementById('root')});
